// Tenant-scoped agent CRUD lives in the tenant API (not the super-admin spec).
// The only piece still useful at the super-admin layer is the template-points-values
// lookup and a DID list; everything else was removed.

import axios from 'api';

// Template points values for a given use-case — /api/super/reference/template-points-values/?usecase=<id>
export const getTemplateValue = ({ usecase__id }) => {
  return axios.get(`/api/super/reference/template-points-values/?usecase=${usecase__id}`);
};

// DID lookup used by the agent picker.
export const getDid = ({ did__country, call_type }) => {
  const params = new URLSearchParams();
  if (did__country) params.set('country', did__country);
  if (call_type) params.set('call_type', call_type);
  params.set('page_size', '1000');
  return axios.get(`/api/super/dids/?${params.toString()}`);
};

// ─── Legacy stubs ────────────────────────────────────────────────────────
import { removedStub } from 'api/_legacy';
export const getAgentConfigActionsData = removedStub('getAgentConfigActionsData');
export const getAgentsData = removedStub('getAgentsData');
export const createAgentData = removedStub('createAgentData');
export const deleteAgent = removedStub('deleteAgent');
export const getAgentDataById = removedStub('getAgentDataById');
export const updateAgent = removedStub('updateAgent');
export const getAgentCoreAction = removedStub('getAgentCoreAction');
export const getAgentCoreLanguage = removedStub('getAgentCoreLanguage');
export const getAgentCoreUseCase = removedStub('getAgentCoreUseCase');
export const getAgentCoreVoice = removedStub('getAgentCoreVoice');
export const getAgentCallType = removedStub('getAgentCallType');
export const fileToText = removedStub('fileToText');
export const getTokens = removedStub('getTokens');
export const createUseCase = removedStub('createUseCase');
export const getEmailIntegrationData = removedStub('getEmailIntegrationData');
export const getCalIntegrationData = removedStub('getCalIntegrationData');
export const getCalEvent = removedStub('getCalEvent');
export const addAgentActions = removedStub('addAgentActions');
export const updateAgentActions = removedStub('updateAgentActions');
export const deleteAgentActions = removedStub('deleteAgentActions');
export const chatAgent = removedStub('chatAgent');
export const testAgent = removedStub('testAgent');
